import React, { Component } from 'react';
import { appImgAlt } from '../config/Config';
import { getUserData, clearUserData } from '../helpers/Common';
import { Username } from '../helpers/User';
import Footer from '../partials/Footer';
export default class PinDeactivated extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: getUserData("appFullDate", true),
            appImgAlt: appImgAlt,
            userName: Username(),
            productName : getUserData('productName', true)
        };
    }
    setBackToLoginWithDelay(delayTime = 15000) {
        clearUserData();
        setTimeout(function () {
            this.props.router.push("login");
        }.bind(this), delayTime);
    }
    componentDidMount() {
        document.body.className = "inner";
        this.setBackToLoginWithDelay();
    }
    render() {
        return (<div className="row">
            <div id="reg_container">
                <div id="reg_header">
                    <header>
                        <div className="logo"><img src={process.env.PUBLIC_URL + '/images/logo.png'} alt="" title={this.state.appImgAlt} border="0" /></div>
                        <div className="top-links reg-page"><img src={process.env.PUBLIC_URL + '/images/calendar_icon.png'} alt="" title="" border="0" /><span>{this.state.date}</span></div>
                    </header>
                    <section className="maincontent" id="frmaddobserver">
                        <section className="content">
                            <h1>PIN Deactivated</h1>
                            <div className="greybgcenter">
                                Hi <span className="greentxt">{this.state.userName}</span>,<br />Your PIN is deactivated for <span className="greentxt">{this.state.productName}</span>. Please Write to <a href="mailto:higheredu@361dm.com" target="_top" style={{color : '#0082c9'}}>higheredu@361dm.com</a> for details.
							</div>
                        </section>
                    </section>
                    <Footer />
                </div>
            </div>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/pages/PinDeactivated.js